import { CheckboxInput, FormItem } from '@framework/form';
import React from 'react';
import { RuleType } from '../../IRule';
import type { IRuleConfigComponentProps } from '../../IRuleType';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage';

const FIELD_NAME = `rules.${RuleType.Required}.value`;
const FIELD_CUSTOM_MESSAGE = `rules.${RuleType.Required}.customMessage`;

export function RequiredRuleComponent(props: IRuleConfigComponentProps) {
  // const {  } = props;

  return (
    <FormItem
      name={FIELD_NAME}
      label={null}
      layout={{ removeLabelSpace: true }}
    >
      <CheckboxInput name={FIELD_NAME} defaultChecked={false}>
        Campo obbligatorio
      </CheckboxInput>
      <CustomValidationRuleMessage isGhostType name={FIELD_CUSTOM_MESSAGE} />
    </FormItem>
  );
}
